import { Button, Modal } from "react-bootstrap";
import FalconCloseButton from "components/common/FalconCloseButton";
import Flex from "components/common/Flex";
import { GetAllClaimsList, ResubmitClaim } from "../config/cliamApi";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
const ErrorResubmitClaimModal = ({
  show,
  onClose,
  body,
  setPage,
  setOpenError,
  setError,
  claimBody,
  setRowsPerPage,
}) => {
  const dispatch = useDispatch();
  const handleHardSubmit = async () => {
    const response = await dispatch(ResubmitClaim(body)).unwrap();
    if (response?.success) {
      setPage(0);
      setRowsPerPage(10);
      toast.success(response?.message_en);
      onClose();
      await dispatch(GetAllClaimsList(claimBody)).unwrap();
    } else {
      setOpenError(true);
      setError(response);
      onClose();
    }
  };
  return (
    <Modal show={show} centered size="md">
      <Modal.Body>
        <FalconCloseButton
          onClick={onClose}
          size="sm"
          className="position-absolute top-0 end-0 me-2 mt-2"
        />
        <Flex direction="column" alignItems="center" className="mb-3">
          <h6 className="fs-9 fw-bold text-danger text-capitalize ">
            Unable to Cancel Previous Claim
          </h6>
          <h6 className="fs-10 text-600 text-center">
            We were unable to cancel your previous claim. You can still resubmit
            this claim, but it might create a duplicate in the payer's system.
          </h6>
          <h6 className="fs-10 text-600 text-center">
            Consider contacting your payer first to confirm before proceeding.
          </h6>
        </Flex>

        <hr />
        <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
          <Button variant="danger" size="sm" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="success" size="sm" onClick={handleHardSubmit}>
            Resubmit Anyway
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ErrorResubmitClaimModal;
